<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <app-form-field-wrapper label="Name" name="name">
    <input
      pInputText
      id="name"
      type="text"
      formControlName="name"
      class="p-input" />
  </app-form-field-wrapper>

  <div class="mx-2 my-3" formGroupName="accessList">
    <div *ngFor="let access of accessList" class="field-checkbox">
      <p-checkbox
        [binary]="true"
        [label]="access.name"
        name="accessList"
        [formControlName]="access.key"></p-checkbox>
    </div>
  </div>

  <p-divider />
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
    "></app-form-footer>
</form>
